import { Box, Stack, Typography } from "@mui/material";

export const columns = [
  // {
  //   accessorKey: "Components",
  //   header: "Material Code",
  //   size: 120,
  //   enableSorting: false,
  //   // muiTableHeadCellProps: { align: "center" },
  // },
  {
    accessorKey: "Cost Code",
    header: "Cost Code",
    size: 100,
    enableHiding: false,
    enableSorting: false,

    Footer: () => {
      return (
        <Stack>
          <Box color="warning.main" sx={{ textAlign: "center" }}>
            TOTAL
          </Box>
        </Stack>
      );
    },
    // muiTableHeadCellProps: { align: "center" },
  },
  {
    accessorKey: "Material Description",
    header: "Material Description",
    size: 290,
    enableHiding: false,
    enableSorting: false,
    // muiTableHeadCellProps: { align: "center" },
  },
  {
    accessorKey: "Total Manhour",
    header: "Total Manhour",
    muiTableBodyCellProps: { align: "right" },
    // muiTableHeadCellProps: { align: "center" },
    Header: (
      <div>
        <div>Est.</div>
        <div>FAB Hours</div>
        <div>Hours</div>
      </div>
    ),
    Cell: ({ cell }) => (
      <>
        {cell.getValue()
          ? Math.round(cell.getValue())
            ? Math.round(cell.getValue())
            : ""
          : ""}
      </>
    ),
    size: 80,
    enableSorting: false,
    Footer: ({ table }) => {
      const total = table
        .getFilteredRowModel()
        .rows.reduce(
          (sum, row) => sum + (Number(row.getValue("Total Manhour")) || 0),
          0
        );
      return (
        <Stack>
          <Box color="warning.main" sx={{ textAlign: "center" }}>
            {total}
          </Box>
        </Stack>
      );
    },
  },
  {
    accessorKey: "actual_hours",
    header: "Actual FAB Hrs",
    Header: (
      <div>
        <div>Actual</div>
        <div>FAB Hours</div>
      </div>
    ),
    size: 90,
    enableSorting: false,
    muiTableBodyCellProps: { align: "right" },
    Cell: ({ cell }) => (
      <>
        {cell.getValue() ? (
          Math.round(cell.getValue()) ? (
            <Typography color={"green"}>
              {Math.round(cell.getValue())}
            </Typography>
          ) : (
            <Typography color={"red"}>Not started yet</Typography>
          )
        ) : (
          <Typography color={"red"}>Not started yet</Typography>
        )}
      </>
    ),
    // muiTableHeadCellProps: { align: "center" },
    // Cell: ({ cell }) => (<>{cell.getValue()?.split(".")[0]}</>),
    Footer: ({ table }) => {
      const total = table
        .getFilteredRowModel()
        .rows.reduce(
          (sum, row) => sum + (Number(row.getValue("actual_hours")) || 0),
          0
        );
      return (
        <Stack>
          <Box color="warning.main" sx={{ textAlign: "center" }}>
            {total}
          </Box>
        </Stack>
      );
    },
  },
  {
    accessorKey: "Remarks",
    header: "Remarks",
    enableSorting: false,
    // muiTableHeadCellProps: { align: "center" },
    size: 100,
  },
  // ...othercolumns
];
